import { axiosEjFetch } from "./axiosEjHelpers";

export async function getAiBudgetPriceList(providerId: string) {
  return axiosEjFetch.get(`/api/aiBudgetPriceAdmin/getprices/${providerId}`);
}

export async function upsertAiBudgetPrice(data: any) {
  return axiosEjFetch.post("/api/aiBudgetPriceAdmin/upsert", data);
}

export async function deleteAiBudgetPrice(id: string) {
  return axiosEjFetch.del(`/api/aiBudgetPriceAdmin/${id}`);
}
